import { TableHead, TableRow } from '@mui/material';
import TableColumn from './TableColumn';
import React from 'react';

export default function CreateTableHeader(param, arrColumn, selectHead, setSelectHead) {
    let columnMerge = param.columnmerge ? param.columnmerge : null;
    return (
        <TableHead>
            {
                columnMerge ?
                    columnMerge.map((item) => (
                        item.column.map((row) => (
                            <TableRow
                                key={param.sTableID + "_" + row.field}
                            >
                                {TableColumn(param, row, selectHead, setSelectHead)}
                            </TableRow>
                        ))

                    ))
                    :
                    <TableRow>
                        {/* {
                        param.isShowCheckBox ? TableColumn(param,elCheckBox,true) : null
                    } */}
                        {
                            arrColumn.map((row) => (
                                TableColumn(param, row, selectHead, setSelectHead)
                            ))
                        }
                    </TableRow>
            }
        </TableHead>
    );
}